export interface Duration {
  hour: number
  minute: number
}

export function fromMinutes(minutes: number): Duration {
  return {
    hour: Math.floor(minutes / 60),
    minute: minutes % 60,
  }
}

export function toMinutes(duration: Duration): number {
  return duration.hour * 60 + duration.minute
}
